import { render, staticRenderFns } from "./filter-region-country.vue?vue&type=template&id=5683b81a"
import script from "./filter-region-country.vue?vue&type=script&lang=js"
export * from "./filter-region-country.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports